import { LazyAction, LazyModule } from 'owa-bundling-light';
import type { LoadMoreState } from './actions/loadMore';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "LoadConversation" */ './lazyIndex')
);

export const lazyLoadConversation = new LazyAction(lazyModule, m => m.loadConversation);
export const lazyLoadMore = new LazyAction(lazyModule, m => m.loadMore);
export const lazyLoadItem = new LazyAction(lazyModule, m => m.loadItem);

export type { LoadMoreState };
